import React, { useState } from 'react';
import { GraduationCap, ArrowRight } from 'lucide-react';
import BookDemoModal from './landing/BookDemoModal';

// Slim announcement bar shown above the site header on every public page.
export default function DemoBanner() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        data-testid="demo-banner"
        className="h-10 bg-gradient-to-r from-[#0F1F3D] via-[#123C7A] to-[#0F1F3D] text-white flex items-center justify-center gap-2.5 sm:gap-3 px-3"
      >
        <span className="relative flex h-2 w-2 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#F5B63F] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#F5B63F]"></span>
        </span>
        <p className="font-body text-xs sm:text-sm flex items-center gap-1.5 whitespace-nowrap">
          <GraduationCap className="w-4 h-4 text-[#F5B63F] flex-shrink-0" />
          <span className="font-semibold">Attend a Free Demo</span>
          <span className="hidden md:inline text-white/70">— experience a live class before you enroll</span>
        </p>
        <button
          onClick={() => setOpen(true)}
          data-testid="demo-banner-get-link"
          className="bg-[#F5B63F] hover:bg-[#E3A62E] text-[#0F1F3D] text-xs sm:text-sm font-bold px-3.5 py-1.5 rounded-lg transition-colors flex items-center gap-1 flex-shrink-0"
        >
          Get Link
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
      {open && <BookDemoModal onClose={() => setOpen(false)} />}
    </>
  );
}
